// Self-contained data for the Cebu Gold Pacific / Gold & Glitz concept redesign website.
export const BIZ = {
  name: "Cebu Gold Pacific — Gold & Glitz",
  brand: "GOLD & GLITZ",
  sub: "Fine Jewelry by Cebu Gold Pacific",
  tagline: "Established 1997 · Osmeña Blvd., Cebu City",
  intro:
    "Cebu Gold Pacific operates pawnshop, money-changing and jewelry services, established in 1997. Its jewelry department is branded Gold & Glitz, offering fine jewelry, gold and diamond settings, customization and handcrafted pieces.",
  address: "155 Osmeña Blvd., Brgy. Sto. Niño, Cebu City 6000, Philippines",
  phone: "(032) 256-3725",
  facebook: "https://www.facebook.com/Goldandglitzph/",
  officialSite: "https://cebugoldpacific.com/gold-and-glitz-jewelry",
  mapEmbed: "https://www.google.com/maps?q=Cebu+Gold+Pacific+155+Osmena+Blvd+Cebu+City&output=embed",
  logoShot: "/cebugold/logo-shot.jpg",
};

export const HIGHLIGHTS = [
  { title: "Established 1997", text: "Nearly three decades operating in Cebu City." },
  { title: "Custom & Handcrafted Pieces", text: "Gold and diamond settings made and customized in-house." },
  { title: "Pawnshop + Jewelry + Money Changer", text: "A multi-service business, with Gold & Glitz as its jewelry brand." },
  { title: "Diamond Settings", text: "Fine diamond and gemstone jewelry alongside gold pieces." },
];

export const PRODUCTS = [
  { name: "Heart Pendant Necklaces", desc: "Gold heart pendant necklace styles from the Gold & Glitz line.", img: "/cebugold/prod-heart.jpg" },
  { name: "Stackable Gold Rings", desc: "Everyday stackable gold ring styles.", img: "/cebugold/prod-rings.jpg" },
  { name: "Greek-Key Gold Hoop Earrings", desc: "Classic Greek-key pattern gold hoop earrings.", img: "/cebugold/prod-hoops.jpg" },
  { name: "Gold Charm Bracelet", desc: "Playful charm-link bracelet, an example of Gold & Glitz's lighter everyday pieces.", img: "/cebugold/prod-charms.jpg" },
];

export const SERVICES = [
  { key: "jewelry", label: "Jewelry", title: "Gold & Glitz Jewelry", text: "Fine and everyday gold jewelry, diamond settings and custom pieces — the focus of this concept site." },
  { key: "pawnshop", label: "Pawnshop", title: "Pawnshop Services", text: "Cebu Gold Pacific's core pawnshop services, running alongside the jewelry counter since 1997." },
  { key: "money", label: "Money Changer", title: "Money Changing", text: "Currency exchange services offered at the same Osmeña Blvd. location." },
];

export const STEPS = [
  { n: "1", title: "Browse", text: "See gold and diamond jewelry styles carried by Gold & Glitz." },
  { n: "2", title: "Ask", text: "Message the official Gold & Glitz Facebook page about a piece." },
  { n: "3", title: "Confirm", text: "Cebu Gold Pacific confirms availability, setting and current price." },
  { n: "4", title: "Buy", text: "Complete your purchase directly at the Osmeña Blvd. store." },
];
